module.exports = __webpack_public_path__ + "img/Conflict Confronter.682b30d3.png";